import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import UploadsBox from '../../components/admin/UploadsBox'
import CurriculumLayout from '../../components/layout/CurriculumLayout'

const Uploads = () => {
  return (
    <AdminLayout>
      <AdminContentLayout>
        <CurriculumLayout title={'Uploads'}>
          <UploadsBox />
        </CurriculumLayout>
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default Uploads
